import axios from 'axios'

const getTeam = async () => axios.get(`${process.env.REACT_APP_URI}/teams`)

export { getTeam }
